import ModelUtil from '@leverege/model-util'

import I18NSystemLanguageModel from './I18NSystemLanguageModel.js'
import I18NNamespaceModel from './I18NNamespaceModel.js'

const TYPE = 'imagine.I18NSystemModel'

function create( extend ) {
  return {
    type : TYPE,
    data : {
      en : I18NSystemLanguageModel.create()
    },
    ...extend
  }
}

const exp = {
  TYPE,
  type : TYPE,
  create,
  ...ModelUtil.createAllValue( 'data' ),
  ...ModelUtil.createAllMap( 'data', 'language', 'languages' ),
  getTranslationData( model ) {
    if ( !model ) {
      return null
    }
    
    return exp.getLanguageEntries( model )
      .reduce( ( prev, [ lang, value ] ) => {
        return {
          ...prev,
          [lang] : I18NSystemLanguageModel
            .getNamespaceEntries( value )
            .reduce( ( prev, [ namespace, namespaceValue ] ) => {
              return {
                ...prev,
                [namespace] : I18NNamespaceModel.getTranslationData( namespaceValue )
              }
            }, {} )
        }
      }, {} )
  }
}

export default exp
